import $ from 'jquery';
import './transition';

var OffCanvas = function() {};

OffCanvas.prototype.init = function(options, elem) {
    this.elem = elem;
    this.$elem = $(elem);

    this.options = options;
    this.isActive = false;

    this._bindEvents(this.options, this.$elem);

    return this;
};

OffCanvas.prototype.isOpen = function(name) {
    return this.isActive;
};

OffCanvas.prototype.close = function(name) {
    var that = this,
        $canvas = that._getCanvas(name),
        $content = $('[data-oc-content=' + name + ']');

    // transitionEnd won't fire for zero second transitions, which we are using
    // for old Safari's and IE. This manually checks for this case, and closes the off-canvas immediately.
    // http://whoknew.dk/transitionend-will-not-fire-with-transition-duration-zero-481.htm

    var durationIsZero = $canvas.css('-webkit-transition-duration') === '0s' ||
        $canvas.css('transition-duration') === '0s';

    if (durationIsZero) {
        that._close($canvas, $content);
    } else {
        $canvas.transitionEnd(function() {
            that._close($canvas, $content);
        });
    }

    $(document).trigger('oc:change', [
        $canvas,
        'close'
    ]);

    $canvas.removeAttr('data-oc-state');
};

OffCanvas.prototype.open = function(name) {
    var that = this,
        $canvas = that._getCanvas(name),
        $content = $('[data-oc-content=' + name + ']'),
        variation = $content.attr('data-oc-variation');

    // set variation
    $canvas.attr('data-oc-variation', variation);

    // animate
    $canvas.attr('data-oc-state', 'active');
    $content.attr('data-oc-state', 'active');

    // add close trigger
    $canvas.one('click', function(e) {
        if (that._getTriggers(name).filter($(e.target)).length === 0) {
            that.close(name);
        }
    });

    this.isActive = true;

    $(document).trigger('oc:change', [
        $canvas,
        'open'
    ]);

    return this;
};

OffCanvas.prototype._bindEvents = function(options, $element) {
    var that = this;

    $.each(options.name.split(' '), function(i, name) {
        $element.on('click', '[data-oc-trigger=' + name + ']', function(e) {
            var $canvas = that._getCanvas(name),
                $content = that._getContent(name);

            // cache the variation info
            $content.attr('data-oc-variation',
                $content.attr('data-oc-variation') || that.options.variation
            );

            // animation triggers
            if (that.isOpen()) {
                that.close(name);
            } else {
                that.open(name);
            }

            return false;
        });
    });
};

OffCanvas.prototype._getContent = function(name) {
    return $('[data-oc-canvas=' + name + ']');
};

OffCanvas.prototype._getCanvas = function(name) {
    return $('[data-oc-canvas~=' + name + ']');
};

OffCanvas.prototype._getTriggers = function(name) {
    return $('[data-oc-trigger~=' + name + ']');
};

OffCanvas.prototype._close = function($canvas, $content) {
    $content.removeAttr('data-oc-state');
    $canvas.removeAttr('data-oc-variation');

    this.isActive = false;
};

export default OffCanvas;



// WEBPACK FOOTER //
// ./~/@99designs/asimov/off-canvas/lib/off-canvas.js